/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

// Enables global config options (see constructor)
// https://www.npmjs.com/package/angular2-highcharts#access-to-the-highcharts-static-api
const Highcharts = require('highcharts');

@Injectable()
export class ChartService {

  private _defaultColors: any[] = [
    'rgba(101, 60, 183, 0.8)',
    'rgba(239, 130, 45, 0.8)'
  ];

  private _primaryGradientColors: any[] = [
    'rgba(101, 60, 183, 1.0)',
    'rgba(101, 60, 183, 0.7)',
    'rgba(101, 60, 183, 0.6)',
    'rgba(101, 60, 183, 0.5)',
    'rgba(101, 60, 183, 0.4)',
    'rgba(101, 60, 183, 0.3)',
    'rgba(101, 60, 183, 0.2)',
    'rgba(101, 60, 183, 0.1)',
    'rgba(101, 60, 183, 0.075)',
    'rgba(101, 60, 183, 0.05)',
    'rgba(101, 60, 183, 0.025)'
  ];

  private _altGradientColors: any[] = [
    'rgba(50, 136, 166, 1)',
    'rgba(50, 136, 166, 0.7)',
    'rgba(50, 136, 166, 0.6)',
    'rgba(50, 136, 166, 0.5)',
    'rgba(50, 136, 166, 0.4)',
    'rgba(50, 136, 166, 0.3)',
    'rgba(50, 136, 166, 0.2)',
    'rgba(50, 136, 166, 0.1)',
    'rgba(50, 136, 166, 0.075)',
    'rgba(50, 136, 166, 0.05)',
    'rgba(50, 136, 166, 0.025)'
  ];

  private _toneColors: any[] = [
    'rgba(70, 176, 93, 0.9)',
    'rgba(217, 195, 87, 0.9)',
    'rgba(184, 73, 84, 0.9)'
  ];

  private _enrichColors: any[] = [
    'rgba(45, 47, 64, 0.9)',
    'rgba(37, 156, 155, 0.9)'
  ];

  private _humanTrendColors: any[] = [
    'rgba(169, 172, 195, 0.9)',
    'rgba(0, 113, 235, 1)'
  ];

  private _defaultChart: any = {
    chart: {
      style: {
        fontFamily: '"Hind", "Helvetica Neue", Helvetica, Arial, sans-serif'
      }
    },
    title: {
      text: null
    },
    colors: this._defaultColors,
    legend: {
      itemStyle: { fontWeight:'normal', fontSize: '14px' }
    },
    xAxis: {},
    yAxis: {},
    plotOptions: {},
    credits: false
  };

  constructor() {
    Highcharts.setOptions({
      lang: {
        thousandsSep: ','
      }
    });
  }

  /**
   * Initialize the default Highcharts chart object
   */
  get defaultChart(): any {
    return JSON.parse(JSON.stringify(this._defaultChart));
  }

  /**
   * Default colors for charts
   */
  get defaultColors(): any[] {
    return JSON.parse(JSON.stringify(this._defaultColors));
  }

  /**
   * Chart colors using primary and gradient to transparent
   */
  get primaryGradientColors(): any[] {
    return JSON.parse(JSON.stringify(this._primaryGradientColors));
  }

  /**
   * Chart colors using alternate and gradient to transparent
   */
  get primaryAltColors(): any[] {
    return JSON.parse(JSON.stringify(this._altGradientColors));
  }

  /**
   * Chart colors using tone [good, medium, bad]
   */
  get toneColors(): any[] {
    return JSON.parse(JSON.stringify(this._toneColors));
  }

  /**
   * Chart colors for Enrich
   */
  get enrichColors(): any[] {
    return JSON.parse(JSON.stringify(this._enrichColors));
  }

  /**
   * Chart colors for Enrich
   */
  get humanTrendColors(): any[] {
    return JSON.parse(JSON.stringify(this._humanTrendColors));
  }
}



// WEBPACK FOOTER //
// ./client/app/services/chart.service.ts